import { render, staticRenderFns } from "./SystemMessages.vue?vue&type=template&id=4d3c014b&"
import script from "./SystemMessages.vue?vue&type=script&lang=js&"
export * from "./SystemMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ccsbetaccscom/web/live/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d3c014b')) {
      api.createRecord('4d3c014b', component.options)
    } else {
      api.reload('4d3c014b', component.options)
    }
    module.hot.accept("./SystemMessages.vue?vue&type=template&id=4d3c014b&", function () {
      api.rerender('4d3c014b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SystemMessages.vue"
export default component.exports